import { Flex, Tooltip, TooltipProps } from '@chakra-ui/react'

export const ElementoTooltip: React.FC<TooltipProps> = ({ children, placement, label, hasArrow, bg, color, p, mr, ...rest }) => {
  const config = {
    placement: placement ?? 'top',
    label: label ?? '',
    hasArrow: hasArrow ?? true,
    bg: bg ?? 'var(--Azul)',
    color: color ?? 'white',
    p: p ?? '.5rem',
    mr: mr ?? ''
  }
  return (
        <Tooltip
            placement={config.placement}
            label={config.label}
            hasArrow={config.hasArrow}
            bg={config.bg}
            color={config.color}
            p={config.p}
            mr={config.mr}
            {...rest}
        >
            <Flex justifyContent={'center'}>
                {children}
            </Flex>
        </Tooltip>
  )
}
